import {useContext, useEffect, useMemo, useRef, useState} from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Button, Container} from "react-bootstrap";
import API, { HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import {Category} from "../models/Category";
import LibraryItem from "../components/LibraryItem";
import CategoryView from "../components/CategoryView";
import TopicFinished from "../components/TopicFinished";
import LibraryFinishedItem from "../components/LibraryFinishedItem";
import "./Library.scss";

export default function Library() {
    const app = useContext(AppContext)

    const [categories, setCategories] = useState([])
    const { enqueueSnackbar } = useSnackbar()

    const [currentCat, setCurrentCat] = useState(null)

    useEffect(() => {
        if(currentCat === null)
            getCategories()

    }, [currentCat, app.user?.current_course, app.ui.locale])

    useEffect(() => {
        if(categories.length > 0) {
            let timer = setTimeout(scrollToElement, 200)
            return () => { clearTimeout(timer) }
        }
    }, [categories]);

    const getCategories = async () => {
        try {
            if(!app.user?.current_course) {
                throw {
                    message: 'Session expired',
                    status: 401
                }
            }

            const res = await API({
                method: 'GET',
                url: `/course/${app.user.current_course}/categories`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            let categories = res.data.items.map((jsonData, idx) => {
                jsonData['selected_topic'] = -1;
                return new Category(jsonData)
            })
            setCategories(categories)
        }
        catch(e) {
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    let recommendedCategory = null
    let totalCompleted = 0;
    categories.forEach((category, idx) => {
        if(category.completed)
            totalCompleted++;

        if(recommendedCategory === null && !category.completed) {
            recommendedCategory = idx
            return false
        }
    })
    let courseCompleted = totalCompleted > 0 && totalCompleted === categories.length;

    const [testOpen, setTestOpen] = useState(false)


    const libRef = useRef(null);

    const scrollToElement = () => {
        let element = document.querySelector('#recommended-category');
        if(!element)
            return;
        let yOffset = -280;

        if(element.classList.contains('expanded')) {
            let child = document.querySelector("#recommended-category .current")
            if(child) {
                element = child
                yOffset = -380;
            }
        }

        if(element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }

    };

    return <div id="page-library" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            {/*<Button variant="info" onClick={() => setTestOpen(true)}>Test Open</Button>*/}
            <div className="finished">
                {testOpen && <TopicFinished buttonText={"Close"} goNext={() => setTestOpen(false)} points={20} message={'Test Message'} title={'YeeHaw!'} perfect={1} />}
            </div>
            <Container fluid className="library-container">
                {categories.map((category, idx) => {
                    return <LibraryItem id={recommendedCategory === idx ? 'recommended-category' : ''} key={'library-cat-' + idx} category={category} currentCat={currentCat}
                                        setCurrentCat={setCurrentCat} recommended={recommendedCategory === idx} />
                                        // ref={recommendedCategory === idx ? libRef : null} />
                })}
                {courseCompleted && <LibraryFinishedItem />}
            </Container>
            <div className="library-container-bg" />
        </div>
        {currentCat !== null && <CategoryView currentCat={currentCat} setCurrentCat={setCurrentCat} />}
    </div>
}